import CryptoJS from "crypto-js"

const key = '1yZaZFBRMX9AWAh!in!B60^B7JuK88rp';

class UserPwd {
    static getUserPwd() {
        let a = localStorage.getItem(key)
        let bytes = CryptoJS.AES.decrypt(a, key);
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decryptedData;
    }

    static setUserPwd(value) {
        let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(value), key).toString();
        return localStorage.setItem(key, ciphertext);
    }

    static removeInfo() {
        return localStorage.removeItem(`operators_info`)
    }

    static has() {
        let a = localStorage.getItem(key)
        return a !== null;
    }
}

export default UserPwd;

















